<template>
  <div class="treeContainer">
    <el-row style="margin: 10px 20px">
      <el-col>
        <el-button @click="previewFront" type="primary" size="mini">
          前台预览
        </el-button>
      </el-col>
    </el-row>

    <el-tree :data="data" node-key="id" :expand-on-click-node="false">
      <span class="custom-tree-node" slot-scope="{ node }">
        <span>
          <span
            v-show="node.level === 3"
            style="
              display: inline-block;
              padding: 2px 3px;
              background: #409eff;
              color: #fff;
            "
            >{{ node.data.type }}</span
          >
          {{ node.label }}
        </span>
      </span>
    </el-tree>
  </div>
</template>

<script>
import * as api from '@/api/courseStructure/courseStructure'
export default {
  data() {
    return {
      courseId: this.$route.query.courseId,
      data: [],
    }
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') 
    },
    url() {
      let url = window.location.protocol + '//' + window.location.host
      if (window.location.host == 'localhost:5001') {
        url = 'http://gz.hnjk.net'
      }
      if (window.location.host == 'fxl.sce.scut.edu.cn') {
        url = url + '/zk'
      }
      return url
    },
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      let reqdata = {
        courseId: this.courseId,
      }
      api.getList(reqdata).then(({ data }) => {
        if (data.code === 100000) {
          data.data.forEach((item) => {
            this.data.push({
              id: item.id,
              label: item.label,
              children: item.children,
            })
          })
        }
      })
    },
    previewFront() {
      window.open(`${this.url}/course/${this.courseId}.html?is_look=1`)
    },
  },
}
</script>

<style lang="scss" scoped>
.treeContainer {
  padding: 16px 20px 40px;
  background-color: #f8f8f8;
  /deep/ .el-tree-node:focus > .el-tree-node__content {
    background-color: rgba(102, 204, 255, 0.445) !important;
  }
  /deep/.el-tree-node__content:hover {
    background-color: rgba(102, 204, 255, 0.445);
  }
  /deep/
    .el-tree--highlight-current
    .el-tree-node.is-current
    > .el-tree-node__content {
    background-color: rgba(102, 204, 255, 0.445);
  }
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }
}
</style>